<div id="cards-container" fxLayout="column" fxFill>
  <div class="searchBox" fxLayout="row" fxLayoutGap="5px">
    <mat-icon svgIcon="search"></mat-icon>
    <input
      id="search-box"
      class="search-box"
      [placeholder]="res('Search') + '...'"
      [(ngModel)]="searchText"
      (input)="applyFilter(searchText)"
    />
    <mat-icon class="clear-search" svgIcon="clear" (click)="clearSearchInput()"></mat-icon>
  </div>
  <div id="card-view-container" fxFlex="calc(100% - 120px)" fxLayout="column" fxLayoutAlign=" stretch">
    <dx-scroll-view>
      <mat-icon
        [ngStyle]="{ visibility: displayArrowBack ? 'visible' : 'hidden' }"
        class="arrowBack"
        svgIcon="arrowBack"
        (click)="prevAction()"
      ></mat-icon>
      @if (map?.size) {
        <div>
          @for (item of map | keyvalue; track item; let index = $index) {
            <div>
              @if (isVisibleOrder(item.value[0].Order)) {
                <abcExpansionPanel
                  #abcExpansionPanel
                  [style]="4"
                  [multiple]="true"
                  [selectedIndex]="index == 0 ? 0 : -1"
                  (onOpen)="openExpansion($event, index)"
                  [collapsible]="displayArrowBack ? true : false"
                  [tooltip]="searchText ? currentFolder : item.value[0].Order?.DisplayText"
                  [count]="item.value.length"
                  [width]="'100%'"
                  [height]="'auto'"
                >
                  <div content="devExpress">
                    <div fxLayout="row wrap" fxLayoutGap="15px grid">
                      @for (obj of item.value; track obj) {
                        <abcCard
                          fxFlex="50"
                          fxFlex.xs="100"
                          [class]="'card-style ' + (obj['IsFolder'] ? 'is-folder' : 'is-document')"
                          id="{{ obj.DisplayText }}"
                          [leftIsImg]="false"
                          [leftIconPosition]="1"
                          [leftIconSize]="2"
                          [leftIconPath]="obj.Order?.LeftIconPath ?? obj.Order?.DisplayText"
                          displayText="{{ obj.DisplayText }}"
                          template="{{ obj.Template }}"
                          [headerDescription]="true"
                          secondaryDisplayText="{{ obj.SecondaryDisplayText }}"
                          description="{{ obj.Description }}"
                          (onCardClick)="navigateTo(obj)"
                          (onCardDblClick)="primaryActionClick(obj)"
                          searchInput="{{ searchText }}"
                          [primaryActionName]="obj.PrimaryAction?.Icon || obj.PrimaryAction?.DisplayText"
                          [primaryActionTooltip]="obj.PrimaryAction?.DisplayText"
                          (onPrimaryActionClick)="primaryActionClick(obj)"
                          [secondaryActionName]="obj.SecondaryAction?.Icon || obj.SecondaryAction?.DisplayText"
                          [secondaryActionTooltip]="obj.SecondaryAction?.DisplayText"
                          (onSecondaryActionClick)="secondaryActionClick(obj)"
                          [thirdActionName]="obj.ThirdAction?.Icon || obj.ThirdAction?.DisplayText"
                          [thirdActionTooltip]="obj.ThirdAction?.DisplayText"
                          (onThirdActionClick)="thirdActionClick(obj)"
                          [fourthActionName]="obj.FourthAction?.Icon || obj.FourthAction?.DisplayText"
                          [fourthActionTooltip]="obj.FourthAction?.DisplayText"
                          (onFourthActionClick)="fourthActionClick(obj)"
                        >
                        </abcCard>
                      }
                    </div>
                  </div>
                </abcExpansionPanel>
              }
            </div>
          }
        </div>
      } @else {
        <div class="empty" fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="20px">
          <mat-icon svgIcon="no-data-icon"></mat-icon>
          <div class="emptyMessage">{{ res('Empty-Message') }}</div>
        </div>
      }
    </dx-scroll-view>
  </div>

  <div class="breadcrumbs">
    <div class="breadcrumbs-path" fxLayout="row" fxLayoutAlign="start center">
      <mat-icon svgIcon="bce-home" class="home-icon" (click)="returnHomePage()"></mat-icon>
      <abc-tile-nav
        [dataSource]="tileNavMap | keyvalue"
        [activeStateEnabled]="true"
        [hoverStateEnabled]="true"
        [fillContent]="true"
        [offset]="70"
        [rtlEnabled]="rtlEnabled"
        (OnTileClick)="onTileClick($event)"
        class="bce-tile-nav"
      ></abc-tile-nav>
    </div>

    @if (currentFolder) {
      <div class="folder-header" fxLayout="row" fxLayoutAlign="start center">
        <div class="vertical-bar"></div>
        <div fxLayout="column">
          <h1 class="folder-title">{{ currentFolder }}</h1>
          <div class="folder-summary">{{ summaryInfo }}</div>
        </div>
      </div>
    }
  </div>
</div>
